
import { defineComponent } from 'vue'
import { TimePeriodEnum } from '../enums'

import { UiTextbox } from './keen-ui'
import { EpbToggle } from './shared/epb-toggle'

export default defineComponent({
  name: 'TimePicker',
  components: {
    UiTextbox,
    EpbToggle,
  },
  props: {
    value: Date,
    disabled: Boolean,
    messages: {
      type: Object,
      required: true,
    },
  },
  computed: {
    values() {
      return this.value
        ? {
            hours: this.getTimeString(this.value.getHours() % 12 || 12),
            minutes: this.getTimeString(this.value.getMinutes()),
            period: this.value.getHours() < 12 ? TimePeriodEnum.AM : TimePeriodEnum.PM,
          }
        : {
            hours: '',
            minutes: '',
            period: TimePeriodEnum.AM,
          }
    },
    periodOptions(): any[] {
      return Object.values(TimePeriodEnum).map((periodId: TimePeriodEnum) => ({
        id: periodId,
        content: this.messages.periods[periodId],
      }))
    },
    timeZone(): string {
      const date = this.value || new Date()
      return date.toLocaleDateString(this.$epb.locale, { timeZoneName: 'short' }).split(' ').pop()
    },
  },
  methods: {
    getTimeString(time: number): string {
      let timeStr = `0${time}`
      timeStr = timeStr.slice(-2)
      return timeStr
    },
    onHoursChange(): void {
      const inputEl: HTMLInputElement = this.$refs.hours.$refs.input as HTMLInputElement
      let hours = Number(inputEl.value)
      if (!isNaN(hours) && hours > 0 && hours <= 12) {
        const newValue = new Date(this.value.getTime())
        if (this.values.period === TimePeriodEnum.AM && hours === 12) {
          hours = 0
        }
        if (this.values.period === TimePeriodEnum.PM && hours < 12) {
          hours += 12
        }
        newValue.setHours(hours)
        this.$emit('input', newValue)
      }
    },
    onMinutesChange(): void {
      const inputEl: HTMLInputElement = this.$refs.minutes.$refs.input as HTMLInputElement
      const minutes = Number(inputEl.value)
      if (!isNaN(minutes) && minutes >= 0 && minutes < 60) {
        const newValue = new Date(this.value.getTime())
        newValue.setMinutes(minutes)
        this.$emit('input', newValue)
      }
    },
    onPeriodChange(periodId: TimePeriodEnum): void {
      const newValue = {
        [TimePeriodEnum.AM]: () => {
          const newDate = new Date(this.value.getTime())
          newDate.setHours(newDate.getHours() - 12)
          return newDate
        },
        [TimePeriodEnum.PM]: () => {
          const newDate = new Date(this.value.getTime())
          newDate.setHours(newDate.getHours() + 12)
          return newDate
        },
      }[periodId]()
      this.$emit('input', newValue)
    },
  },
})
